<iframe #VAiframe *ngIf="sourceVAUrl" [src]="sourceVAUrl" (load)="vaIframeOnLoad(VAiframe)" style="border: 0;clip: rect(0 0 0 0);height: 1px;margin: -1px;overflow: hidden;padding: 0;position: absolute;width: 1px;"></iframe>
